import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '../../../../common/button';
import { Modal, ResponsiveWidth } from '../../../../common/modal';
import { ICancelAppointmentModalProps } from './cancel-appointment-modal.models';
import { useStyles } from './cancel-appointment-modal.styles';
import { getCancelAppointmentTextIds } from './utils';

export const CancelAppointmentModal = ({
  onClose, onCancelAppointment, appointmentType, ...props
}: ICancelAppointmentModalProps): JSX.Element => {
  const classes = useStyles();
  const { titleId, descriptionId } = getCancelAppointmentTextIds(appointmentType);

  return (
    <Modal
      {...props}
      onClose={onClose}
      responsiveWidth={ResponsiveWidth.md}
      title={(
        <FormattedMessage
          id={titleId}
        />
      )}
      content={(
        <p className={classes.description}>
          <FormattedMessage
            id={descriptionId}
          />
        </p>
      )}
      footer={(
        <div className={classes.actions}>
          <Button
            fullWidth
            variant="contained"
            onClick={onCancelAppointment}
            data-testid="cancel-button"
          >
            <FormattedMessage
              id="appointmentCancel.cancelButton.label"
            />
          </Button>
          <Button
            fullWidth
            variant="outlined"
            onClick={onClose as () => void}
            data-testid="close-button"
          >
            <FormattedMessage
              id="appointmentCancel.closeButton.label"
            />
          </Button>
        </div>
      )}
    />
  );
};
